import { observable, action } from "mobx";
import moment from "moment";

export default class CreditAccount {
  /**
   * @property {number|null}
   */
  @observable creditAccountId = null;

  /**
   * @property {number|null}
   */
  @observable providerId = null;

  /**
   * @property {number|null}
   */
  @observable creditUsageId = null;

  /**
   * @property {number|null}
   */
  @observable creditCardTransactionId = null;

  /**
   * @property {number|null}
   */
  @observable amount = null;

  /**
   * @property {string}
   */
  @observable description = "";

  /**
   * @property {string}
   */
  @observable creationDts = null;

  constructor(data) {
    if (typeof data !== "undefined") {
      this.setData(data);
    }
  }

  @action setData({
    creditAccountId = null,
    providerId = null,
    creditCardTransactionId = null,
    creditUsageId = null,
    amount = null,
    description = "",
    creationDts = null,
  }) {
    this.creditAccountId = creditAccountId;
    this.providerId = providerId;
    this.creditCardTransactionId = creditCardTransactionId;
    this.creditUsageId = creditUsageId;
    this.amount = amount;
    this.description = description;
    this.creationDts = creationDts ? moment(creationDts) : null;
  }

  @action
  setAmount(amount) {
    this.amount = amount;
  }

  @action
  setDescription(description) {
    this.description = description;
  }
}
